import { FC } from 'react';

type Props = {
	className?: string;
};

const FaqIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M9.99935 18.3334C14.6017 18.3334 18.3327 14.6025 18.3327 10.0001C18.3327 5.39771 14.6017 1.66675 9.99935 1.66675C5.39698 1.66675 1.66602 5.39771 1.66602 10.0001C1.66602 14.6025 5.39698 18.3334 9.99935 18.3334Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='square'
				strokeLinejoin='round'
			/>
			<path
				d='M10 13.75H10.0075'
				stroke='inherit'
				strokeWidth='1.66667'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.33301 7.91667C8.33301 6.99619 9.07917 6.25 9.99967 6.25C10.9202 6.25 11.6663 6.99619 11.6663 7.91667C11.6663 8.24846 11.5694 8.55758 11.4023 8.81733C10.9042 9.59142 9.99967 10.3295 9.99967 11.25'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default FaqIcon;
